// extracted by mini-css-extract-plugin
export default {"title":"StudentInfo_title__vjcyS","avater":"StudentInfo_avater__zq1wL","label":"StudentInfo_label__HkjZn","item":"StudentInfo_item__V2OvO","error":"StudentInfo_error__D7OZM"};